import { Pipe, PipeTransform } from '@angular/core';
import { StepStatusEnum } from '../../enums/step-status';

@Pipe({
  name: 'stepStatus',
  standalone: true,
})
export class StepStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case StepStatusEnum.COMPLETED:
        return 'bg-success-500 text-white';

      case StepStatusEnum.INPROGRESS:
      case StepStatusEnum.PENDING:
      case StepStatusEnum.EDITED:
        return 'bg-warning-500 text-white';

      case StepStatusEnum.REJECTED:
      case StepStatusEnum.SENT_FORWARD:
      case StepStatusEnum.SENT_BACK:
      case StepStatusEnum.CANCELLED:
        return 'bg-destructive-500 text-white';

      case StepStatusEnum.SCHEDULED:
        return 'bg-primary-500 text-white';

      case StepStatusEnum.SKIPPED:
        return 'bg-neutral-50 text-neutral-700';

      case StepStatusEnum.NOT_STARTED:
        return 'bg-neutral-50 text-neutral-700!';

      case StepStatusEnum.NO_ACTION:
        return 'bg-neutral-50 text-neutral-700';

      case StepStatusEnum.ON_HOLD:
        return 'bg-neutral-900 text-white';
    }
    return '';
  }
}
